import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import get from 'lodash/get';
import getWindow from '@loggi/js/get-window';
import Col, { SIZES } from '@loggi/ui/components/col';
import Display from '@loggi/ui/components/display';
import Divider from '@loggi/ui/components/divider';
import Icon from '@loggi/ui/components/icon';
import LoaderMask from '@loggi/ui/components/loader-mask';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import screen from '@loggi/ui/components/utils/screens';
import View from '@loggi/ui/components/view';
import ViewContainer from '@loggi/ui/components/view-container';
import { packageTrackerModel } from 'public-tracker/public-tracker.models/package-tracker.model';
import emoji from 'images/sad.png';
import { locationModel } from 'app/app.models';
import StatusCard from 'shared/card/status-card/status-card.component';
import callMutation from 'shared/relay/mutations/call-mutation';
import getStatus from 'shared/status/get-status.service';
import getLayout from 'shared/status/get-layout.service';
import {
  GOING_TO_RECIPIENT,
  IN_RECIPIENT,
  IN_SENDER
} from 'shared/status/status.constants';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import * as actionsTracker from 'tracker.actions';
import {
  ETA_LABEL,
  PACKAGE_TRACKING_NO_FORECAST,
  FEEDBACK_ALERT_ERROR_TITLE,
  CLOSE_BUTTON_VALUE
} from 'tracker.constants';
import { PATH_PACKAGE_TRACKING, CONFIRM_DELIVERY } from 'tracker.routes';
import queryString from 'query-string';
import ConfirmedDeliveryMessage from '../../../app/package/main-package-info-card/confirmed-delivery-message/confirmed-delivery-message.component';
import { RECEIVED_BY_MESSAGE } from '../../../shared/status/status-eta-message-constants';
import confirmDeliveryWithoutAuthMutation from '../../../app/package/main-package-info-card/confirm-delivery/confirm-delivery-without-auth.mutation';
import { PackageTrackingFooter } from '../../components/package-tracking-footer/package-tracking-footer.component';
import AuthCard from '../auth-card/auth-card.component';
import ConfirmDelivery from '../../../app/package/main-package-info-card/confirm-delivery/confirm-delivery.component';
import dnrContextService from './package-status.service';
import styles from '../status.styles.scss';
import {
  STATUS_TO_NOT_RENDER_FORECAST_DATE,
  STATUS_TO_RENDER_FORECAST_INFO
} from './package-status.constants';
import { CONFIRM_DELIVERY_ERROR_DESCRIPTION } from '../../../app/package/package.constants';
import RecipientPickupText from '../../../shared/recipient-pickup-text/recipient-pickup-text.component';
import {
  AppBeyondMobile,
  AppBeyond
} from '../../components/app-beyond/app-beyond.component';
import { LOGGIAPP_ORIGIN_IDENTIFYER } from '../../../tracker.constants';

const { inAnyDestination, inSender } = PACKAGE_TRACKING_NO_FORECAST;

export class PackageStatus extends React.Component {
  constructor(props) {
    super(props);

    const wasDeliveredByRecipient = get(
      this.props,
      'location.state.wasDelivered',
      null
    );
    this.state = {
      isLoading: get(props, 'shouldLoadQuery', false),
      receivedBy: null,
      recipientRelationship: null,
      locationCode: null,
      recipientInfo: null,
      enableComplementaryDeliveryInfoLayout: false,
      shouldConfirmPackageDelivery: false,
      isConfirmDeliveryButtonsDisabled: false,
      wasDeliveredByRecipient,
      userFeedbackAlert: false
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { shouldLoadQuery } = this.props;

    if (shouldLoadQuery) {
      const { match, relay } = this.props;
      this.setState({ isLoading: true });
      const { companySecretId, trackingKey } = match.params;
      relay.forceFetch({ companySecretId, trackingKey });
    }
  }

  async componentDidMount() {
    const { actions } = this.props;
    const pathname = this._generateUrl();
    const uuid = this._getUuid();

    getWindow().ga('set', 'page', pathname);
    getWindow().ga('send', 'pageview');

    if (uuid) {
      const queryProps = await dnrContextService.getDnrContext(uuid);
      const {
        receivedBy,
        recipientInfo,
        shouldConfirmPackageDelivery,
        recipientRelationship,
        locationCode,
        enableComplementaryDeliveryInfoLayout
      } = queryProps.deliveryNotReceivedContext;

      this.setState({
        receivedBy,
        recipientInfo,
        shouldConfirmPackageDelivery,
        recipientRelationship,
        locationCode,
        enableComplementaryDeliveryInfoLayout
      });
    }

    return actions.savePhoneNumber({
      packageTracker: null
    });
  }

  _formatEta = (eta, packageDelivered, packageGoingToDelivery) => {
    const currentDate = moment();
    const etaIsCurrentDate = eta
      ? moment.unix(eta).isSame(currentDate, 'day')
      : null;
    if (packageGoingToDelivery || (etaIsCurrentDate && !packageDelivered)) {
      return ETA_LABEL.today;
    }
    if (eta) {
      if (packageDelivered && etaIsCurrentDate) {
        return `${ETA_LABEL.todayAt}${moment.unix(eta).format('LT')}`;
      }
      return moment.unix(eta).format('DD/MM/YYYY');
    }
    return '- -';
  };

  _renderForecast = forecastDisplayInfoLabel => {
    return (
      <Col className={styles.packageStatus} gutter={{ bottom: 'quarter' }}>
        <Text>{forecastDisplayInfoLabel}</Text>
      </Col>
    );
  };

  _getUuid = () => {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    return query.pdcbr_uuid;
  };

  _onConfirmDeliveryMutation = ({ wasDeliveredByRecipient }) => {
    const variables = {
      input: {
        pdcbrUuid: this._getUuid(),
        wasDelivered: wasDeliveredByRecipient
      }
    };

    const callbacks = {
      onSuccess: response =>
        this._onSuccessConfirmDeliveryMutation(response, {
          wasDeliveredByRecipient
        }),
      onFailure: this._onFailureConfirmDeliveryMutation
    };

    return callMutation(
      confirmDeliveryWithoutAuthMutation,
      variables,
      callbacks
    );
  };

  _onClickToConfirmDelivery = () => {
    this.setState({ isConfirmDeliveryButtonsDisabled: true });
    this._onConfirmDeliveryMutation({ wasDeliveredByRecipient: true });
  };

  _onClickToDenyDelivery = () => {
    this._goToNextScreen(CONFIRM_DELIVERY);
  };

  _goToNextScreen = nextPathname => {
    const {
      history,
      location,
      location: { search }
    } = this.props;

    const {
      receivedBy,
      recipientInfo,
      shouldConfirmPackageDelivery,
      recipientRelationship,
      locationCode,
      enableComplementaryDeliveryInfoLayout
    } = this.state;
    const uuid = this._getUuid();
    let { pathname } = location;

    // Prepare pathname to next path
    if (pathname.charAt(pathname.length - 1) === '/') {
      pathname = pathname.slice(0, -1);
    }

    return history.push({
      pathname: `${pathname}/${nextPathname}`,
      state: {
        receivedBy,
        recipientInfo,
        shouldConfirmPackageDelivery,
        recipientRelationship,
        locationCode,
        enableComplementaryDeliveryInfoLayout,
        uuid,
        previousPage: `${pathname}`,
        packageStatusPath: `${pathname}`,
        packageStatusSearch: `${search}`
      }
    });
  };

  _onClickToCloseAlert = () => {
    this.setState({ userFeedbackAlert: false });
  };

  _onFailureConfirmDeliveryMutation = () => {
    return this.setState({
      isConfirmDeliveryButtonsDisabled: false,
      userFeedbackAlert: true
    });
  };

  _onSuccessConfirmDeliveryMutation(
    { packageTrackerDeliveryConfirmationByRecipientWithoutAuth },
    { wasDeliveredByRecipient }
  ) {
    const {
      success
    } = packageTrackerDeliveryConfirmationByRecipientWithoutAuth;
    if (!success) {
      return this._onFailureConfirmDeliveryMutation();
    }
    return this.setState({ wasDeliveredByRecipient });
  }

  _getOrigin() {
    const { location } = this.props;
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get('origin');
  }

  _isLoggiAppRequest() {
    return this._getOrigin() === LOGGIAPP_ORIGIN_IDENTIFYER;
  }

  _generateUrl() {
    const packageTracker = get(this.props, 'viewer.packageTracker', false);
    const trackingKey = get(packageTracker, 'packageInfo.trackingKey', null);
    const companyHash = get(packageTracker, 'packageInfo.companyHash', null);
    return `${PATH_PACKAGE_TRACKING}/${companyHash}/${trackingKey}/validador`;
  }

  render() {
    const packageTracker = get(this, 'props.viewer.packageTracker', false);
    const { history } = this.props;
    if (!packageTracker) {
      history.push(`${PATH_PACKAGE_TRACKING}`);
      return null;
    }

    const {
      packageInfo: { packageId },
      destinationInfo: { firstLine },
      redispatchInfo,
      canAuthenticate
    } = packageTracker;

    const {
      isLoading,
      receivedBy,
      shouldConfirmPackageDelivery,
      recipientRelationship,
      locationCode,
      enableComplementaryDeliveryInfoLayout,
      isConfirmDeliveryButtonsDisabled,
      wasDeliveredByRecipient,
      userFeedbackAlert
    } = this.state;

    const { getScreen, sizes } = screen;
    const {
      eta,
      packageInfo,
      relativeEta,
      currentStatus,
      shipperStatus
    } = packageTracker;

    const { trackingKey, companyName } = packageInfo;
    const { trackingCode, maxPickupTime } = redispatchInfo;

    const packageStatus = getStatus(packageTracker);
    const packageDelivered = packageStatus === IN_RECIPIENT;
    const packageGoingToDelivery = packageStatus === GOING_TO_RECIPIENT;

    const {
      color,
      forecastDisplayInfoLabel,
      pkKeyDisplayInfoLabel
    } = getLayout(packageStatus);

    const formattedEtaDate = this._formatEta(
      eta,
      packageDelivered,
      packageGoingToDelivery
    );

    const isRedispatchRecipientPickup =
      trackingCode != null && maxPickupTime != null;

    const shouldRenderForecastDate =
      !STATUS_TO_NOT_RENDER_FORECAST_DATE.includes(packageStatus) &&
      !isRedispatchRecipientPickup;

    const shouldRenderForecastInfo =
      (packageStatus === IN_SENDER && !isRedispatchRecipientPickup) ||
      (STATUS_TO_RENDER_FORECAST_INFO.includes(packageStatus) &&
        shouldRenderForecastDate &&
        !eta);

    const statusInfo = {
      companyName,
      currentStatus,
      shipperStatus,
      relativeEta,
      eta,
      redispatchInfo
    };
    const userFeedbackAlertProps = {
      illustration: emoji,
      title: FEEDBACK_ALERT_ERROR_TITLE,
      description: CONFIRM_DELIVERY_ERROR_DESCRIPTION,
      buttonsProps: [
        {
          value: CLOSE_BUTTON_VALUE,
          onClick: this._onClickToCloseAlert
        }
      ]
    };

    return (
      <Col flex size={12}>
        <Col size={{ md: 6, lg: 6, xl: 7, xxl: 7 }} className="package-wrapper">
          <Col
            flex
            flexDirection="column"
            size={{ md: 12, lg: 12, xl: 10, xxl: 10 }}
            gutter={{
              xs: { top: 'triple', left: 'double', right: 'double' },
              sm: { top: 'double' }
            }}
            className="main-content"
            backgroundColor={colors.type.WHITE}
          >
            <StatusCard
              statusInfo={statusInfo}
              isOriginLoggiApp={this._isLoggiAppRequest()}
            />
            <View
              flexDirection="row"
              gutter={{ top: 'double', bottom: 'double' }}
            >
              {shouldRenderForecastDate && !shouldRenderForecastInfo && (
                <Col
                  size={5}
                  gutter={{ xs: { right: 'half' } }}
                  justifyContent="start"
                >
                  <ViewContainer fluid>
                    {this._renderForecast(forecastDisplayInfoLabel)}
                    <Col size={12}>
                      <Text color={colors.type.BLACK} title>
                        {formattedEtaDate}
                      </Text>
                    </Col>
                  </ViewContainer>
                </Col>
              )}
              {shouldRenderForecastInfo && (
                <Col
                  size={6}
                  gutter={{ top: 'half' }}
                  flexDirection="row"
                  justifyContent="around"
                  alignItems="start"
                >
                  <Col gutter={{ right: 'half' }}>
                    <Icon
                      type={icons.type.CALENDAR}
                      color={color}
                      className="display-small"
                    />
                  </Col>
                  <Text small color={colors.type.DARKEST}>
                    {packageStatus === IN_SENDER ? inSender : inAnyDestination}
                  </Text>
                </Col>
              )}
              {shouldRenderForecastDate && (
                <Col
                  gutter={
                    shouldRenderForecastInfo
                      ? {
                          top: 'half',
                          left: 'half',
                          right: 'onehalf'
                        }
                      : { top: 'half', right: 'normal' }
                  }
                >
                  <Divider direction="vertical" color={colors.type.SMOKE_100} />
                </Col>
              )}
              {isRedispatchRecipientPickup ? (
                <Col size={SIZES.COL_12}>
                  <RecipientPickupText
                    trackingCode={trackingCode}
                    maxPickupTime={maxPickupTime}
                  />
                </Col>
              ) : (
                <Col
                  size={shouldRenderForecastInfo ? SIZES.COL_6 : SIZES.COL_7}
                >
                  <ViewContainer fluid>
                    <Col
                      className={styles.packageStatus}
                      gutter={{ bottom: 'quarter' }}
                    >
                      <Text>{pkKeyDisplayInfoLabel}</Text>
                    </Col>
                    <Col className={styles.wordBreakAll} size={SIZES.COL_12}>
                      <Text>{trackingKey}</Text>
                    </Col>
                  </ViewContainer>
                </Col>
              )}
            </View>
            <Divider color={colors.type.SMOKE_100} />
            {shouldConfirmPackageDelivery ? (
              <Col>
                {!enableComplementaryDeliveryInfoLayout && receivedBy && (
                  <ViewContainer>
                    <Text size="300" weight="bold">
                      {RECEIVED_BY_MESSAGE}{' '}
                      <Text weight="bolder">{receivedBy}</Text>.
                    </Text>
                  </ViewContainer>
                )}
                {wasDeliveredByRecipient === null && (
                  <Col gutter={{ top: 'onehalf', bottom: 'onehalf' }}>
                    <ConfirmDelivery
                      onClickToDeny={this._onClickToDenyDelivery}
                      onClickToConfirm={this._onClickToConfirmDelivery}
                      isDisabled={isConfirmDeliveryButtonsDisabled}
                      receivedBy={receivedBy}
                      locationCode={locationCode}
                      recipientRelationship={recipientRelationship}
                      enableComplementaryDeliveryInfoLayout={
                        enableComplementaryDeliveryInfoLayout
                      }
                    />
                  </Col>
                )}
              </Col>
            ) : (
              <div>
                {canAuthenticate && (
                  <View flexGrow="1">
                    <Display when={isLoading}>
                      <LoaderMask />
                    </Display>
                    <AuthCard
                      mainAddress={firstLine}
                      packageId={packageId}
                      history={history}
                    />
                  </View>
                )}
              </div>
            )}
            {wasDeliveredByRecipient && <ConfirmedDeliveryMessage />}
            {!this._isLoggiAppRequest() && (
              <PackageTrackingFooter isSmallScreen={getScreen() < sizes.md} />
            )}
          </Col>
          {!this._isLoggiAppRequest() && <AppBeyondMobile />}
        </Col>
        <AppBeyond />
        {userFeedbackAlert && (
          <UserFeedbackAlert
            illustration={userFeedbackAlertProps.illustration}
            title={userFeedbackAlertProps.title}
            description={userFeedbackAlertProps.description}
            buttonsProps={userFeedbackAlertProps.buttonsProps}
          />
        )}
      </Col>
    );
  }
}

PackageStatus.displayName = 'PackageStatus';

PackageStatus.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  viewer: PropTypes.shape(packageTrackerModel).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      companySecretId: PropTypes.string.isRequired,
      trackingKey: PropTypes.string.isRequired,
      packageId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  actions: PropTypes.shape({
    savePhoneNumber: PropTypes.func.isRequired
  }).isRequired,
  shouldLoadQuery: PropTypes.bool,
  relay: PropTypes.shape({
    forceFetch: PropTypes.func.isRequired
  }),
  history: PropTypes.func.isRequired,
  location: PropTypes.shape(locationModel)
};

PackageStatus.defaultProps = {
  shouldLoadQuery: null,
  relay: null,
  location: { state: null }
};

function mapStateToProps({ packageTracking }) {
  return packageTracking;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actionsTracker, dispatch)
  };
}

const PackageStatusContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageStatus);

export default PackageStatusContainer;
